<template>
  <a-tabs
    :activeKey="activeKey"
    type="card"
    class="search-image-platform-tabs"
    @change="changePlatform"
  >
    <a-tab-pane
      v-for="platform in platformList"
      :key="platform.value"
      :tab="getItemCount(platform)"
    />
  </a-tabs>
</template>
<script>
export default {
  props: {
    activeKey: String,
    platformList: Array,
    getGoodsList: Array,
    loading: Boolean
  },
  computed: {
    getItemCount() {
      return (item) => {
        return `${item.label}${!this.loading  && item.value === this.activeKey && this.getGoodsList?.length ? ' (' + this.getGoodsList.length + ')' : ''}`
      }
    }
  },
  methods: {
    changePlatform(value) {
      this.$emit("change-activeKey", value)
    }
  }
}
</script>
<style scoped lang='less'>
  .search-image-platform-tabs {
    margin-top: .4em;
    :deep(.ant-tabs-bar) {
      margin-bottom: 5px;
      .ant-tabs-nav-container {
        height: 32px;
        .ant-tabs-tab {
          font-size: 15px;
          height: 32px;
          line-height: 31px;
        }
      }
    }
  }
</style>